import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUEST_METHODS } from '@app/constants/request-methods';
import { RequestBuilderService } from '@app/services/request-builder/request-builder.service';
import { IData, IPaginatedData, ITableAction } from '@app/types/data-tables';
import { map } from 'rxjs';
import { IClient } from '../../types/client';
import { ICompanyReferences } from '../../types/company-references';
import { ICompanyPayload } from '../../types/company.payload';
import { IMDMCustomerResult } from '../../types/mdm-customer';
import {
    IGenerateQROnboardingPayload,
    IQROnboardingDetails,
} from '../../types/qr-onboarding';

@Injectable({
    providedIn: 'root',
})
export class CompaniesService {
    private requestBuilderService = inject(RequestBuilderService);

    addCompany(param: ICompanyPayload) {
        return this.requestBuilderService.post<string>(
            REQUEST_METHODS.V1.Companies.SaveClient,
            param,
            null,
        );
    }

    addCompanyDraft(param: ICompanyPayload) {
        return this.requestBuilderService.post<string>(
            REQUEST_METHODS.V1.Companies.SaveClientDraft,
            param,
        );
    }

    generateQrOnboarding(param: IGenerateQROnboardingPayload) {
        return this.requestBuilderService.post<IQROnboardingDetails>(
            REQUEST_METHODS.V1.Companies.QrOnboarding,
            param,
        );
    }

    getMDMCustomers(customerName: string) {
        return this.requestBuilderService
            .get<IMDMCustomerResult>(REQUEST_METHODS.V1.Search.MDM(customerName))
            .pipe(
                map((res) => {
                    return res.result;
                }),
            );
    }

    getQROnboardingDetails(qrCodeId: string) {
        return this.requestBuilderService.get<IQROnboardingDetails>(
            REQUEST_METHODS.V1.Companies.QrOnboardingDetails(qrCodeId),
        );
    }

    getReferences() {
        return this.requestBuilderService.get<ICompanyReferences>(
            REQUEST_METHODS.V1.References.ClientForm,
        );
    }

    getClients({ page, pageSize, search, sort, sortBy }: Omit<ITableAction, 'onFetch'>) {
        const queryData = {
            PageNumber: page,
            PageSize: pageSize,
            SearchQuery: search ?? '',
            sort: sort ?? '',
            sortBy: sortBy ?? '',
        };
        const paramsData = {};

        Object.entries(queryData).forEach(([key, value]) => {
            if (value) {
                Object.assign(paramsData, { [key]: value });
            }
        });

        const params = new HttpParams({ fromObject: paramsData });

        return this.requestBuilderService.get<IPaginatedData<IData<IClient>>>(
            `${REQUEST_METHODS.V1.Search.Clients}?${params.toString()}`,
        );
    }
}
